module.exports = __webpack_public_path__ + "img/icon-support.c36c2751.png";